/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Campaign_ArchivedInputs */

const en_error_sales_campaign_archived = /** @type {(inputs: Error_Sales_Campaign_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The campaign is archived: restore it to change it or to book for it.`)
};

/**
* | output |
* | --- |
* | "The campaign is archived: restore it to change it or to book for it." |
*
* @param {Error_Sales_Campaign_ArchivedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_campaign_archived = /** @type {((inputs?: Error_Sales_Campaign_ArchivedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Campaign_ArchivedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_campaign_archived(inputs)
});